import React from "react";
import RestroApp from "../../assets/restroapp.png";
import Khadyanna from "../../assets/khadyanna.png";
import portfolio from "../../assets/portfolio.png";
import ecommerce from "../../assets/ecommerce.png";
import ECOM from "../../assets/flutterecommerce.png";

const Projects = ({ id }) => {
  return (
    <div id={id}>
      <section class="text-gray-400 body-font bg-gray-900">
        <div class="container px-5 py-10 md:py-20 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-white">
                Here are my projects.
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
            </div>
            <p class="lg:w-1/2 w-full leading-relaxed text-gray-400 text-opacity-90 text-right">
              List of projects that I have worked on.
            </p>
          </div>
          <div class="flex flex-wrap -m-4">
            <a
              target="_blank"
              href="https://prayash-shrestha.netlify.app/"
              class="w-full md:w-1/2 p-4"
            >
              <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg h-full">
                <img
                  class="h-[50vh]  rounded w-full object-contain object-center mb-6"
                  src={portfolio}
                  // src='https://dummyimage.com/720x400'
                  alt="content"
                />
                <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font">
                  Portfolio website
                </h3>
                <h2 class="text-lg text-white font-medium title-font mb-4">
                  Developer
                </h2>
                <p class="leading-relaxed text-base">
                  A responsive portfolio website created from scratch using
                  TailwindCSS.
                </p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://github.com/Prahyas/restro-app-with-backend"
              class="w-full md:w-1/2 p-4"
            >
              <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg h-full">
                <img
                  class="h-[50vh]  rounded w-full object-contain object-center mb-6"
                  src={RestroApp}
                  // src='https://dummyimage.com/720x400'
                  alt="content"
                />
                <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font">
                  Restaurant Management System
                </h3>
                <h2 class="text-lg text-white font-medium title-font mb-4">
                  RestroApp
                </h2>
                <p class="leading-relaxed text-base">
                  The web-based POS application that streamlines order
                  management and invoice printing for small restaurants.
                </p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://github.com/Prahyas/khadyanna-frontend/tree/main"
              class="w-full md:w-1/2 p-4"
            >
              <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg h-full">
                <img
                  class="h-[50vh]   rounded w-full object-contain object-center mb-6"
                  src={Khadyanna}
                  alt="content"
                />
                <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font">
                  Record Keeping System
                </h3>
                <h2 class="text-lg text-white font-medium title-font mb-4">
                  Khadyanna
                </h2>
                <p class="leading-relaxed text-base">
                  An specialized record-keeping system for inventory and
                  transactions of food grains.
                </p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://github.com/Prahyas/completeEcommerce"
              class="w-full md:w-1/2 p-4"
            >
              <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg h-full">
                <img
                  class="h-[50vh]   rounded w-full object-contain object-center mb-6"
                  src={ecommerce}
                  alt="content"
                />
                <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font">
                  Full ecommerce system
                </h3>
                <h2 class="text-lg text-white font-medium title-font mb-4">
                  completeEcommerce
                </h2>
                <p class="leading-relaxed text-base">
                  A ecommerce platform with Stripe API integration. It will be a
                  complete ecommerce site with a admin template to manage data
                  and can accept payments through stripe.
                </p>
              </div>
            </a>
            {/* <div class="w-full md:w-1/2 p-4">
              <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg h-full">
                <img
                  class="h-[50vh]   rounded w-full object-contain object-center mb-6"
                  src={ECOM}
                  alt="content"
                />
                <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font">
                  Flutter Application
                </h3>
                <h2 class="text-lg text-white font-medium title-font mb-4">
                  Ecommerce App
                </h2>
                <p class="leading-relaxed text-base">
                  Ecommerce app is a mobile application providing sales and
                  business management as a service for a range of businesses.
                </p>
              </div>
            </div>
            <div class="w-full md:w-1/2 p-4">
              <div class="bg-gray-800 bg-opacity-40 p-6 rounded-lg h-full">
                <img
                  class="h-[50vh]   rounded w-full object-contain object-center mb-6"
                  src="https://dummyimage.com/723x403"
                  alt="content"
                />
                <h3 class="tracking-widest text-indigo-400 text-xs font-medium title-font">
                  Song Management System
                </h3>
                <h2 class="text-lg text-white font-medium title-font mb-4">
                  Believe
                </h2>
                <p class="leading-relaxed text-base">
                  A song management system to upload and manage the songs of
                  different clients.
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
